import {
  createAction,
  createGetter,
  createMutation,
  mutate,
  on,
  RemoteObjectStore,
  select,
  StoreFeature
} from '@softline/core';
import {User} from '../data/user.model';
import {UserResourceService} from '../services/user-resource.service';
import {RegistrationCandidate} from '../data/registration-candidate.model';

const RegistrationAdminObjectStore = RemoteObjectStore.create<RegistrationCandidate>();
export type State = RemoteObjectStore.State<RegistrationCandidate> & ExtensionState;

interface ExtensionState {
  creating: boolean;
}

export class RegistrationAdminStore {

  static mutations = {
    ...RegistrationAdminObjectStore.mutations,
    setCreating: createMutation<ExtensionState, boolean>('setCreating')
  };

  static getters = {
    ...RegistrationAdminObjectStore.getters,
    getCreating: createGetter<ExtensionState, boolean>('getCreating')
  };

  static actions = {
    ...RegistrationAdminObjectStore.actions,
    createUser: createAction<ExtensionState, { user: User }, User>('createUser')
  };

  static feature: StoreFeature<State> = {
    initialState: {
      ...RegistrationAdminObjectStore.feature.initialState,
      creating: false
    },
    mutations: [
      ...RegistrationAdminObjectStore.feature.mutations,
      mutate(RegistrationAdminStore.mutations.setCreating, ({ state, params }) => ({ ...state, creating: params}))
    ],
    getters: [
      ...RegistrationAdminObjectStore.feature.getters,
      select(RegistrationAdminStore.getters.getCreating, ({ state}) => ( state.creating ))
    ],
    actions: [
      ...RegistrationAdminObjectStore.feature.actions,
      on(RegistrationAdminStore.actions.createUser, async ({ state, store, injector, params, featureName }) => {
        store.commit(featureName, RegistrationAdminStore.mutations.setCreating, true);
        const service = injector.get(UserResourceService);
        const user = await service.create(params.user);
        store.commit(featureName, RegistrationAdminStore.mutations.setCreating, false);
        return user;
      })
    ]
  };
}


